import React from 'react';
import { ICellProps } from './type';
import classNames from 'classnames';
import './index.scss';

export const Cell = (props: ICellProps) => {
  const { className, style, children, config } = props;
  const { column } = config || {};
  const { align } = column || {};

  return (
    <div className={classNames("dbd-common-table__cell", className, {
      'dbd-common-table__cell--left': align === 'left',
      'dbd-common-table__cell--right': align === 'right',
      'dbd-common-table__cell--center': align === 'center',
    })} style={style}>
      {children}
    </div>
  );
};
